import React, { Component } from 'react';
import { Box, CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';

// My components
import Navbar from './Navbar';
import SideMenu from './SideMenu';

// Styled components
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleDrawer = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { children, isDarkTheme, toggleTheme, toogleTranslation } = this.props;

    return (
      <Box style={{ display: 'flex' }}>
        <CssBaseline />
        {/* Top navigation bar */}
        <Navbar
          open={this.state.open}
          handleDrawer={this.handleDrawer}
          toggleTheme={toggleTheme}
          toogleTranslation={toogleTranslation}
          isDarkTheme={isDarkTheme}
        />

        {/* Left navigation bar */}
        <SideMenu
          open={this.state.open}
          handleDrawer={this.handleDrawer}
          DrawerHeader={DrawerHeader}
          isDarkTheme={isDarkTheme}
        />

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          {children}
        </Box>
      </Box>
    );
  }
}

export default Layout;
